export interface Promotion {
  id: string;
  title: string;
  type: string;
  startDate: number;
  endDate: number;
  status: string;
}

export function isPromotionExpired(promotion: Promotion): boolean {
  return promotion.endDate != null && promotion.endDate < Date.now() / 1000;
}

export function setCachedPromotions(pendingPromotions: Promotion[], cacheName: string): void {
  if (pendingPromotions.length > 0) {
    localStorage.setItem(cacheName, JSON.stringify(pendingPromotions))
  } else {
    localStorage.removeItem(cacheName)
  }
}
